import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { PLAYER_DASHBOARD_FILTER_SOURCE, SCOPE_CONTEXT_FILTER_KEYS } from '@/analytics/snowplow/filterTracking';
import { useTrackFilterChanges } from '@/analytics/snowplow/hooks/useTrackFilterChanges';
import { unwrappedSelectedPlayerNameAtom } from '@/atoms/player/info';
import { PageTitle } from '@/components/head/PageTitle';
import { DashboardContentFallback } from '@/components/layout/DashboardContentFallback';
import { PlayerLayoutWithFilters } from '@/components/layout/player/PlayerLayoutWithFilters';
import { FirstTimeModalAiSummary } from '@/components/modal/FirstTimeModals/FirstTimeModalAiSummary';
import { PitchVisSettingsPanel } from '@/components/settings/PitchVisSettingsPanel';
import { useEntityPageTitle } from '@/hooks/useEntityPageTitle';
import { OnboardingItemKey } from '@/types/userConfigs';
import { PlayerDashboardWithData } from './PlayerDashboardWithData';

export const PlayerDashboardPage = () => {
  const { t } = useTranslation('navigation');
  const playerName = useAtomValue(unwrappedSelectedPlayerNameAtom);
  const heading = t('secondary.dashboard');
  const pageTitle = useEntityPageTitle(heading, playerName);
  useTrackFilterChanges(SCOPE_CONTEXT_FILTER_KEYS, PLAYER_DASHBOARD_FILTER_SOURCE);

  return (
    <>
      <PageTitle>{pageTitle}</PageTitle>
      <PlayerLayoutWithFilters settingsPanel={<PitchVisSettingsPanel />}>
        <DashboardContentFallback>
          <PlayerDashboardWithData />
        </DashboardContentFallback>
      </PlayerLayoutWithFilters>
      <FirstTimeModalAiSummary modalType={OnboardingItemKey.AI_SUMMARY_PLAYER} />
    </>
  );
};
